// extracted by extract-css-chunks-webpack-plugin
module.exports = {"BigLoader":"BigLoader_3Xy_c_v13-0-0","BigLoader__Text":"BigLoader__Text_15FS9_v13-0-0","__Before-React-Loaded":"__Before-React-Loaded_2H0-g_v13-0-0"};
    if(module.hot) {
      // 1588357787681
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  